/* eslint-disable */
import { GETADVERTISEMENT, GETPASTADVERTISEMENT, GETCHALLANDETAILS, GETCHALLANCANDIDATES, UPLOADCHALLANDETAILS, SENDCHALLANDETAILSTOBANK, DOWNLOADBANKFILE } from "../../common/constants/endpoints";
import API from "../../helpers/API";
import { SET_ADVERTISEMENT_VIEW, SET_GET_ACTIVE_ADVERTISEMENT, SET_GET_PAST_ADVERTISEMENT, SET_CHALLAN_DETAILS, SET_CANDIDATES_CHALLAN_DETAILS, SET_CANDIDATES_CHALLAN_UPLOAD, SET_ADVERTISEMENT_LIST_PAGE_NO_COUNTER} from '../../common/constants/ActionTypes';
import FileDownload from "js-file-download";
import { toastr } from 'react-redux-toastr';
import dayjs from 'dayjs';

export const setAdvertisementInfoDisplay = (flag) => {
    return async (dispatch) => {
        dispatch({
            payload: flag,
            type: SET_ADVERTISEMENT_VIEW
        })
    }
};
export const getAdvertisement = (skipPage,limitPage, year) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        let response;
        try {
            response = await API.get(GETADVERTISEMENT + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { "year": year }
            });
            dispatch({
                type: SET_GET_ACTIVE_ADVERTISEMENT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getPastAdvertisement = (skipPage,limitPage, year) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        let response;
        try {
            response = await API.get(GETPASTADVERTISEMENT + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { "year": year}
            });
            dispatch({
                type: SET_GET_PAST_ADVERTISEMENT,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const getChallanDetails = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GETCHALLANDETAILS + `${id}` + '/challandetails', {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_CHALLAN_DETAILS,
                payload: response.data,
            });

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getChallanCandidates = (id, skipPage, limitPage,save) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let skip = Number(skipPage);
        let pageLimit = Number(limitPage);
        try {
            response = await API.get(GETCHALLANCANDIDATES + `${id}` + '/challancandidates' + `/${skip}` + `/${pageLimit}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_CANDIDATES_CHALLAN_DETAILS,
                payload: response.data,
            });
            dispatch({
                type: SET_ADVERTISEMENT_LIST_PAGE_NO_COUNTER,
                payload: (skip * pageLimit),
            });
            if(save=="save"&&response.data){
                toastr.success(response.data.message);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}
export const uploadChallanList = (data, advtNo) => {
    return async (dispatch) => {
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;

            const formData = new FormData();
            if (data.file) {
                formData.append('file', data.file);
            }
            if (data.action === "upload") {
                formData.append('showOnlySummary', true);
            }
            if (data.action === "save") {
                formData.append('showOnlySummary', false);
            }

            const header = {
                'Authorization': `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            };

            const response = await API.post(UPLOADCHALLANDETAILS, formData, {
                headers: header
            });

            dispatch({
                type: SET_CANDIDATES_CHALLAN_UPLOAD,
                payload: response.data,
            });

            if (data.action === "upload") {
                toastr.success("File Uploaded Successfully");
            }
            if (data.action === "save") {
                // toastr.success("Challan Saved Successfully");
                // toastr.success(response.data.message)
                dispatch(clearChallanListCandidates());
                dispatch(getChallanCandidates(advtNo, 0, 10,"save"));
            }
        } catch (error) {
            toastr.error(error.response && error.response.data && error.response.data.message || "An error occurred");
        }
    };
};

export const clearChallanListCandidates = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_CANDIDATES_CHALLAN_UPLOAD,
            payload: [],
        });
    }
}

export const sendChallanDetailsToBank = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(SENDCHALLANDETAILSTOBANK, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toastr.success("Challan Details Send Successfully");
            dispatch(getChallanCandidates(id, 0,10))
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const downloadBankFile = (applicationIdList) => {
    return async function (dispatch) {
        let response;
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;
            response = response = await API.patch(DOWNLOADBANKFILE, applicationIdList, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data == "Records not found!") {
                toastr.error(response.data);
            }
            dispatch(resetCandidateListCheckbox())

        } catch (error) {
            toastr.error("File not available to download");
            return;
        }
        if (response.data != "Records not found!") {
            FileDownload(
                response.data,
                `Challan_details_${dayjs(new Date()).format('MMM DD,YYYY h:mm A')}.txt`
            );
        }
    }
}
export const resetCandidateListCheckbox = () => {
    return async function (dispatch, getState) {
        const { candidateChallanDetails } = getState().challanManagementReducer;
        dispatch({
            type: SET_CANDIDATES_CHALLAN_DETAILS,
            payload: candidateChallanDetails.candidateChallanDetails
                .map((result) => ({
                    ...result,
                    isInterested: false,
                })),
        });

    }
}